(function () {
  var zoomEl = null;
  var zoomImg = null;
  var zoomImgWrap = null;
  var openModalCount = 0;

  function ensureZoomElement() {
    if (zoomEl) return;
    zoomEl = document.createElement('div');
    zoomEl.id = 'photo-card-zoom';
    zoomEl.className = 'pc-zoom';
    zoomEl.setAttribute('aria-hidden', 'true');
    zoomEl.style.display = 'none';
    zoomEl.innerHTML =
      '<div class="pc-zoom-overlay"></div>' +
      '<div class="pc-zoom-dialog">' +
      '<button type="button" class="pc-zoom-close" aria-label="閉じる">&times;</button>' +
      '<div class="pc-zoom-img-wrap"></div>' +
      '</div>';
    document.body.appendChild(zoomEl);
    zoomImgWrap = zoomEl.querySelector('.pc-zoom-img-wrap');
    zoomEl.querySelector('.pc-zoom-overlay').addEventListener('click', closePhotoCardZoom);
    zoomEl.querySelector('.pc-zoom-close').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closePhotoCardZoom();
    });
  }

  function openPhotoCardModal(modalId) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    document.querySelectorAll('[id="' + modalId + '"]').forEach(function (node) {
      if (node !== modal) {
        node.remove();
      }
    });
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.style.display = 'flex';
    openModalCount += 1;
    document.body.style.overflow = 'hidden';
  }

  function closePhotoCardModal(modalId) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    modal.style.display = 'none';
    openModalCount = Math.max(0, openModalCount - 1);
    if (openModalCount === 0 && !isZoomOpen()) {
      document.body.style.overflow = '';
    }
  }

  function isZoomOpen() {
    return zoomEl && zoomEl.style.display === 'block';
  }

  function openPhotoCardZoom(src, alt) {
    ensureZoomElement();
    if (!zoomImg) {
      zoomImg = document.createElement('img');
      zoomImg.className = 'pc-zoom-img';
      zoomImgWrap.appendChild(zoomImg);
    }
    zoomImg.src = src;
    zoomImg.alt = alt || '';
    zoomImg.width = 1600;
    zoomImg.height = 1600;
    zoomEl.style.display = 'block';
    zoomEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePhotoCardZoom() {
    if (!zoomEl) return;
    zoomEl.style.display = 'none';
    zoomEl.setAttribute('aria-hidden', 'true');
    if (zoomImg) {
      zoomImg.remove();
      zoomImg = null;
    }
    if (openModalCount === 0) {
      document.body.style.overflow = '';
    }
  }

  function addToCart(form, onSuccess) {
    if(form.dataset.f61Preview === 'true') {var status=form.querySelector('[data-preview-status]');status.textContent='確認用：'+new FormData(form).get('properties[フォーマット番号]')+' を選択しました。カートへの送信は行っていません。';return;}
    if(form.dataset.adding==='true')return;
    form.dataset.adding='true';var button=form.querySelector('[type="submit"]');if(button)button.disabled=true;
    var root=window.Shopify?.routes?.root||'/';
    var formData;
    Promise.resolve().then(function(){
      var variantInput=form.querySelector('[name="id"]');
      if(variantInput && variantInput.value)return;
      var handle=form.dataset.productHandle;
      if(!variantInput || !handle)throw new Error('商品情報を読み込めませんでした。もう一度お試しください。');
      return fetch(root+'products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'}).then(function(r){
        if(!r.ok)throw new Error('商品情報を読み込めませんでした。もう一度お試しください。');
        return r.json();
      }).then(function(product){
        var variants=Array.isArray(product.variants)?product.variants:[];
        var variant=variants.find(function(item){return item.available})||variants[0];
        if(!variant || !variant.id)throw new Error('商品をカートに追加できませんでした。');
        variantInput.value=variant.id;
      });
    }).then(function(){
      formData=new FormData(form);if(!formData.has('quantity'))formData.append('quantity','1');
      if(!form.matches('.photo-card-modal-form'))return;
      return fetch(root+'cart.js',{credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error('カートを確認できませんでした。もう一度お試しください。');return r.json()}).then(function(cart){if(!Array.isArray(cart.items))throw new Error('カートを確認できませんでした');if(cart.items.some(function(x){return String(x.variant_id)===String(formData.get('id'))}))throw new Error('写真掲載オプションはすでにカートに入っています。カートの内容をご確認ください。')});
    }).then(function(){return fetch(root+'cart/add.js',{method:'POST',body:formData,credentials:'same-origin'})}).then(function(r){if(!r.ok)return r.json().then(function(e){throw new Error(e.description||'カートに追加できませんでした')});return r.json()}).then(onSuccess).catch(function(error){alert('エラー: '+error.message)}).finally(function(){delete form.dataset.adding;if(button)button.disabled=false});
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('.photo-card-open-modal');
    if (openBtn) {
      e.preventDefault();
      openPhotoCardModal(openBtn.getAttribute('data-modal-id'));
      return;
    }

    var closeBtn = e.target.closest('.photo-card-modal-close');
    if (closeBtn) {
      e.preventDefault();
      closePhotoCardModal(closeBtn.getAttribute('data-modal-id'));
      return;
    }

    var overlay = e.target.closest('.photo-card-modal-overlay');
    if (overlay) {
      var modal = overlay.closest('.photo-card-modal');
      if (modal) {
        closePhotoCardModal(modal.getAttribute('data-modal-id') || modal.id);
      }
      return;
    }

    var prevBtn = e.target.closest('.pc-carousel-prev');
    if (prevBtn) {
      e.preventDefault();
      var prevCarousel = prevBtn.closest('.pc-carousel');
      var prevTrack = prevCarousel ? prevCarousel.querySelector('.pc-carousel-track') : null;
      if (prevTrack) {
        prevTrack.scrollBy({ left: -prevTrack.offsetWidth, behavior: 'smooth' });
      }
      return;
    }

    var nextBtn = e.target.closest('.pc-carousel-next');
    if (nextBtn) {
      e.preventDefault();
      var nextCarousel = nextBtn.closest('.pc-carousel');
      var nextTrack = nextCarousel ? nextCarousel.querySelector('.pc-carousel-track') : null;
      if (nextTrack) {
        nextTrack.scrollBy({ left: nextTrack.offsetWidth, behavior: 'smooth' });
      }
      return;
    }

    var zoomBtn = e.target.closest('.pc-carousel-zoom-btn');
    if (zoomBtn) {
      e.preventDefault();
      openPhotoCardZoom(zoomBtn.getAttribute('data-zoom-src'), zoomBtn.getAttribute('data-zoom-alt'));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;

    if (form.matches('.collection-display-add-form') && !form.closest('.photo-card-modal')) {
      e.preventDefault();
      addToCart(form, function () {
        sessionStorage.setItem('scrollToCart', 'true');
        window.location.reload();
      });
      return;
    }

    if (form.matches('.photo-card-modal-form')) {
      e.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      var modalId = form.getAttribute('data-modal-id');
      addToCart(form, function () {
        closePhotoCardModal(modalId);
        sessionStorage.setItem('scrollToCart', 'true');
        window.location.reload();
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (sessionStorage.getItem('scrollToCart') === 'true') {
      sessionStorage.removeItem('scrollToCart');
      var target = document.querySelector('#cart-totalarea');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }

    document.querySelectorAll('cart-remove-button a').forEach(function (button) {
      button.addEventListener('click', function () {
        setTimeout(function () {
          window.location.reload();
        }, 800);
      });
    });
  });

  // Delegated handlers survive Shopify cart section replacement.
  function photo61Panel(p,open){const t=p.querySelector('[data-f61-toggle]');p.querySelector('[data-f61-panel]').hidden=!open;t.setAttribute('aria-expanded',String(open));}
  document.addEventListener('click',e=>{
   const toggle=e.target.closest('[data-f61-toggle]');if(toggle){const p=toggle.closest('[data-f61-picker]');photo61Panel(p,p.querySelector('[data-f61-panel]').hidden);return;}
   const pick=e.target.closest('[data-f61-choose]');if(!pick)return;
   const m=pick.closest('.photo-card-modal'),p=pick.closest('[data-f61-picker]'),s=m.querySelector('[name="properties[フォーマット番号]"]');s.value=pick.dataset.f61Choose;s.dispatchEvent(new Event('change',{bubbles:true}));photo61Panel(p,false);const t=p.querySelector('[data-f61-toggle]');t.scrollIntoView({block:'nearest'});t.focus({preventScroll:true});
  });
  document.addEventListener('change',e=>{
   if(e.target.name!=='properties[フォーマット番号]')return;const m=e.target.closest('.photo-card-modal');if(!m)return;const p=m.querySelector('[data-f61-picker]');if(!p)return;
   const card=[...p.querySelectorAll('[data-f61-card]')].find(c=>c.dataset.f61Card===e.target.value),selection=p.querySelector('[data-f61-selection]');
   p.querySelectorAll('[data-f61-choose]').forEach(b=>{const yes=b.dataset.f61Choose===e.target.value;b.setAttribute('aria-pressed',String(yes));if(!b.querySelector('img'))b.textContent=yes?'✓ 選択中':'このデザインを選ぶ';});
   selection.replaceChildren();if(card){const img=card.querySelector('img').cloneNode();img.loading='eager';const label=document.createElement('span');label.textContent=card.dataset.f61Card+'｜'+card.dataset.title;selection.append(img,label);}else selection.textContent='デザインを選択してください';
  });
  document.addEventListener('invalid',e=>{if(e.target.name!=='properties[フォーマット番号]')return;const m=e.target.closest('.photo-card-modal'),p=m&&m.querySelector('[data-f61-picker]');if(!p)return;e.preventDefault();photo61Panel(p,true);p.querySelector('[data-f61-selection]').textContent='画像からデザインを選択してください';p.querySelector('[data-f61-toggle]').focus();},true);
})();
